import React from "react";


const Logo = ({...rest}) => (
    <img className="logo" src='/foundationLogo.svg' alt="foundation logo" aria-label="foundation logo" {...rest}/>
);

export default Logo;
